import { type FC } from "react";
import { Check } from "lucide-react";

import { Tag } from "@/shared/components/ui/tag";
import { Card, CardContent } from "@/shared/components/ui/card";

interface AuthorityResultsCardProps {
  heading: string;
  description: string;
}

export const AuthorityResultsCard: FC<AuthorityResultsCardProps> = ({
  heading,
  description,
}) => {
  return (
    <Card className="bg-white">
      <CardContent className="pt-6 flex flex-col gap-3">
        <Tag color="stone" icon={Check} className="w-fit px-[10px] py-[2px] text-[13px]">
          Your results
        </Tag>
        <p className="text-base font-semibold tracking-[-0.32px]">{heading}</p>
        <p className="text-sm text-secondary tracking-[-0.28px]">{description}</p>
      </CardContent>
    </Card>
  );
};
